<template>
	<div>
		<div class="h3 ftw600">
			<!-- 交易訂單 -->
			{{$t('studentsCom.tradingOrder')}}
		</div>
		<div class="p-3 br12 bg-w mt-4">
			<a-tabs v-model:activeKey="activeKey" class="" @change="changeTab()">
				<a-tab-pane key="1" :tab="$t('studentsCom.completedOrders')">
						<div class="border-gray py-2 d-flex ftr-1 cl-black ftw600">
							<div class="tr-wid-20 px-3">
								<!-- 交易時間 -->
								{{$t('studentsCom.transactionTime')}}
							</div>
							<div class="tr-wid-20 px-3">
								<!-- 老師姓名 -->
								{{$t('studentsCom.teacherName')}}
							</div>
							<div class="tr-wid-20 px-3">
								<!-- 課程内容 -->
								{{$t('studentsCom.courseContent')}}
							</div>
							<div class="tr-wid-10 px-3">
								{{$t('addClass.classNumber')}}
							</div>
							<div class="tr-wid-20 px-3">
								{{$t('studentsCom.amount')}}（{{getCurrency()}}）
							</div>
							<div class="tr-wid-30 px-3">
								<!-- 訂單號 -->
								{{$t('studentsCom.orderNumber')}}
							</div>
						</div>
						<div class="border-gray py-2 d-flex ftr-1" style="border-top: none !important;"
						v-for="(item,index) in list">
							<div class="tr-wid-20 px-3">
								{{convertToTimeZone(item.createtime).formattedTime }}
							</div>
							<div class="tr-wid-20 px-3">
								{{item.name}} {{item.surname}}
							</div>
							<div class="tr-wid-20 px-3">
								{{item.course_name}}
							</div>
							<div class="tr-wid-10 px-3">
								{{item.quantity}}
							</div>
							<div class="tr-wid-20 px-3 cl-theme">
								{{getCurrency()}} {{convertCurrency(item.initial_price)}}
							</div>
							<div class="tr-wid-30 px-3">
								{{item.order_sn}}
							</div>
						</div>
				</a-tab-pane>
				<a-tab-pane key="2" :tab="$t('studentsCom.refundedOrders')">
					<div class="border-gray py-2 d-flex ftr-1 cl-black ftw600">
						<div class="tr-wid-20 px-3">
							<!-- 交易時間 -->
							{{$t('studentsCom.transactionTime')}}
						</div>
						<div class="tr-wid-20 px-3">
							<!-- 老師姓名 -->
							{{$t('studentsCom.teacherName')}}
						</div>
						<div class="tr-wid-20 px-3">
							<!-- 課程内容 -->
							{{$t('studentsCom.courseContent')}}
						</div>
						<div class="tr-wid-10 px-3">
							{{$t('addClass.classNumber')}}
						</div>
						<div class="tr-wid-20 px-3">
							{{$t('studentsCom.amount')}}（{{getCurrency()}}）
						</div>
						<div class="tr-wid-30 px-3">
							<!-- 訂單號 -->
							{{$t('studentsCom.orderNumber')}}
						</div>
					</div>
					<div class="border-gray py-2 d-flex ftr-1" style="border-top: none !important;"
					v-for="(item,index) in list">
						<div class="tr-wid-20 px-3">
							{{convertToTimeZone(item.createtime).formattedTime }}
						</div>
						<div class="tr-wid-20 px-3">
							{{item.name}} {{item.surname}}
						</div>
						<div class="tr-wid-20 px-3">
							{{item.course_name}}
						</div>
						<div class="tr-wid-10 px-3">
							{{item.quantity}}
						</div>
						<div class="tr-wid-20 px-3 cl-theme">
							{{getCurrency()}} {{convertCurrency(item.initial_price)}}
						</div>
						<div class="tr-wid-30 px-3">
							{{item.order_sn}}
						</div>
					</div>
				</a-tab-pane>
			</a-tabs>
			<div class="mt-3">
				<div>如不想繼課堂或想更換老師，請按此 <span class="cl-theme"> 申請課程退款至Mira Coins</span></div> 
				
				<div class="mt-2 cl-black ftw500">退課安排及細則</div>   
				<div>1. 所有已購買課堂不能退回現金，僅可退回Mira Coins至帳戶錢包作往後購課使用；</div> 
				<div>2. 支付時的手續費將恕不退回；</div>
				<div>3. 僅可退回未完成的課堂，並會以原價(減去折扣及所有優惠)，計算退課的餘額； </div>
				<div>4. 僅可退回未預約的課堂(需取消所有預約)，12小時內已預約的課堂未能退課。</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				activeKey: '1',
				status:1,
				list:[]
			}
		},
		created(){
			this.getOrderList()
		},
		methods:{
			changeTab(){
				this.list = []
				if(this.activeKey== '1'){
					this.getOrderList()
				}else{
					this.getOrderListone()
				}
			},
			getOrderList(){
				this.$http.api('order/orderList',{
					status:3
				}).then(res=>{
					this.list = res.list
				})
			},
			getOrderListone(){
				this.$http.api('order/orderList',{
					is_exception:1,
					status:3
				}).then(res=>{
					this.list = res.list
				})
			}
		}
	}
</script>

<style>
	.tr-wid-20{
		width: 20%;
	}
	.tr-wid-30{
		width: 30%;
	}
	.tr-wid-10{
		width: 10%;
	}
	.ant-tabs-nav .ant-tabs-tab {
		font-size: 16px;
	}
	
	.ant-tabs-nav .ant-tabs-tab:hover {
		color: #52C4C9;
	}
	
	.ant-tabs-nav .ant-tabs-tab-active {
		color: #52C4C9;
		text-shadow: 0 0 0.25px #52C4C9
	}
	
	.ant-tabs-ink-bar {
		background-color: #52C4C9;
	}
</style>